import React, { useEffect, useMemo, useState } from "react";
import Datepicker from "../../CommonComponents/Datepicker";
import Timepicker from "../../CommonComponents/Timepicker";
import InputField from "../../CommonComponents/InputField";
import Checkbox from "../../CommonComponents/Checkbox";
import PartialProctorIcon from "../../../Svg/PartialProctorIcon";
import ProctorIconsvg from "../../../Svg/ProctorIconSvg";
import DualProctoringIcon from "../../../Svg/DualProctoringIcon";
import Button from "../../Button";
import Radio from "../../CommonComponents/Radio";
import { BATCH_TYPE, libTypeIds, MODE } from "../../../constants";
import NoProctoringIcon from "../../../Svg/NoProctoringIcon";
import LocationProctoringIcon from "../../../Svg/LocationProctoringIcon";
import dayjs from "dayjs";

const EMPTY_ITEM = {};

const Publish = ({
  isDuedateUpdate = false,
  item = EMPTY_ITEM,
  onChange = null,
  onSave = null,
  onCancel = null,
  batchType = BATCH_TYPE.LEARNING,
  from
}) => {
  const [inputData, setInputData] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [disableSave, setDisableSave] = useState(batchType !== BATCH_TYPE.SELF);
  const [isApiCall, setIsApiCall] = useState(false);

  const proctoringMode = useMemo(
    () => [
      {
        id: 2,
        icon: <ProctorIconsvg />,
        head: "Complete Proctoring",
        desc: "Webcam + Tab Switch",
        value: 2,
      },
      {
        id: 3,
        icon: <PartialProctorIcon />,
        head: "Partial Proctoring",
        desc: "Tab Switch only",
        value: 1,
      },
      {
        id: 5,
        icon: <LocationProctoringIcon />,
        head: "Complete + Location proctoring",
        desc: "Webcam + Tab Switch + Location",
        value: 4,
      },
      {
        id: 1,
        icon: <DualProctoringIcon />,
        head: "Dual Proctoring",
        desc: "Webcam + Mobile Camera + Tab Switch",
        value: 3,
      },
    ],
    [],
  );

  useEffect(() => {
    if (item.libTypeId === libTypeIds.ASSIGNMENT && item.templateId) {
      proctoringMode.push({
        id: 4,
        icon: <NoProctoringIcon />,
        head: "No Proctoring",
        desc: "Publish test without Image capture and Tab switch",
        value: 0,
      });
    } else if (item.videoAssessment) {
      const findIndex = proctoringMode.findIndex((mode) => mode.id === 3);
      if (findIndex) {
        proctoringMode.splice(findIndex, 1);
      }
    }
  }, [item, proctoringMode]);

  useEffect(() => {
    const copyItem = structuredClone(item);
    if (!isDuedateUpdate) copyItem.proctored = 2;
    setInputData({ ...copyItem });
  }, [isDuedateUpdate, item]);

  const onChangeInput = (field, value) => {
    setInputData((pre) => ({
      ...pre,
      [field]: value,
    }));
    onChange && onChange(field, value);
  };

  const onSaveData = async () => {
    const copyData = structuredClone(inputData);
    console.log("selectedDate", selectedDate, "selectedTime", selectedTime);

    const formattedDuedate =
      selectedDate && selectedTime
        ? dayjs(
          `${selectedDate.format("YYYY-MM-DD")} ${selectedTime.format(
            "HH:mm",
          )}`,
        ).format("YYYY-MM-DD HH:mm:ss")
        : null;
    copyData.dueDate = formattedDuedate;
    if (from === "publishall") {
      if (!formattedDuedate) {
        setDisableSave(true);
      }
      setDisableSave(true);
      setIsApiCall(true);
      onSave && (await onSave(formattedDuedate));
      setDisableSave(false);
      setIsApiCall(false);
      return;
    }
    if (!copyData.dueDate) {
      setDisableSave(true);
    }
    setDisableSave(true);
    setIsApiCall(true);
    onSave && (await onSave(copyData));
    setDisableSave(false);
    setIsApiCall(false);
  };

  const buttonText = `${!isDuedateUpdate ||
    (inputData.testMode === MODE.PRACTICE_MODE && inputData.published === 0)
    ? `${isApiCall ? "Publishing" : "Publish"}`
    : `${isApiCall ? "Saving" : "Save"}`
    }`;

  return (
    <div className="admin-path-module-chapter-detail-publish-modal-content">
      {batchType !== BATCH_TYPE.SELF && (
        <div className="admin-path-module-chapter-detail-deadline-field-container">
          <p className="admin-path-module-chapter-detail-deadline-title">
            Set deadline *
          </p>
          <div className="admin-path-module-chapter-detail-deadline-field-wrapper">
            <Datepicker
              className="admin-path-module-chapter-detail-deadline-date-picker"
              value={selectedDate}
              onChange={(value) => {
                if (value && selectedTime) setDisableSave(false);
                setSelectedDate(value);
              }}
              minDate={dayjs()}
            />
            <Timepicker
              className="admin-path-module-chapter-detail-deadline-date-picker admin-path-module-chapter-detail-deadline-time-picker"
              selectedTime={selectedTime}
              setSelectedTime={(value) => {
                if (value && selectedDate) setDisableSave(false);
                setSelectedTime(value);
              }}
            />
          </div>
        </div>
      )}
      {
        from !== "publishall" && (
          <>
            <div className="admin-path-module-chapter-detail-deadline-field-wrapper">
              <InputField
                name="weightage"
                type="number"
                label="Set weightage"
                value={inputData.weightage}
                onChange={(event) =>
                  onChangeInput(event.target.name, event.target.value)
                }
                placeholder="Weightage"
                className="admin-path-module-chapter-detail-weightage-field"
              />
              {item.testMode && (
                <InputField
                  name="target"
                  type="number"
                  label="Target %"
                  value={inputData.target}
                  onChange={(event) =>
                    onChangeInput(event.target.name, event.target.value)
                  }
                  placeholder="Target percentage"
                  className="admin-path-module-chapter-detail-target-percent-field"
                />)}
            </div>
            <Checkbox
              size="sm"
              text="Pin Test"
              className="admin-path-module-chapter-detail-pintest-field"
              checked={inputData.pinneddate}
              onChange={(checked) => onChangeInput("pinneddate", checked)}
            />
          </>
        )
      }
      {(!isDuedateUpdate ||
        (inputData.testMode === MODE.PRACTICE_MODE &&
          inputData.published === 0) ||
        (inputData.libTypeId === libTypeIds.ASSIGNMENT &&
          inputData.published === 0)) && from !== "publishall" && (
          <Checkbox
            size="sm"
            text="Notify students via email after publishing"
            className="admin-path-module-chapter-detail-pintest-field"
            checked={inputData.isNotify ?? false}
            onChange={(checked) => onChangeInput("isNotify", checked)}
          />
        )}
      {!isDuedateUpdate && from !== "publishall" && (
        <div className="admin-path-module-chapter-detail-proctored-field-wrapper">
          <p className="admin-path-module-chapter-detail-proctored-title">
            Select Proctoring
          </p>
          {proctoringMode.map((mode) => (
            <div
              className="admin-path-module-chapter-detail-proctored-field"
              key={mode.id}
              onClick={() => onChangeInput("proctored", mode.value)}
            >
              <div className="admin-path-module-chapter-detail-proctored-field-info-wrapper">
                <div>{mode.icon}</div>
                <div className="admin-path-module-chapter-detail-proctored-field-info">
                  <div className="admin-path-module-chapter-detail-proctored-field-head">
                    {mode.desc}
                  </div>
                  {/* <div className="admin-path-module-chapter-detail-proctored-field-caption">
                    {mode.desc}
                  </div> */}
                </div>
              </div>
              <Radio
                size="sm"
                checked={inputData.proctored === mode.value}
                onChange={(event) => null}
              />
            </div>
          ))}
        </div>
      )}

      <div className="admin-path-module-chapter-detail-publish-btn-container">
        <Button
          size="lg"
          hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
          onClick={onCancel}
        />
        <Button
          size="lg"
          hierarchy={{
            type: "primary",
            buttonText: buttonText,
          }}
          onClick={onSaveData}
          disable={disableSave}
        />
      </div>
    </div>
  );
};

export default Publish;
